import { Component} from '@angular/core';

@Component({
  selector: 'app-density-vertical-header',
  standalone: false,
  templateUrl: './density-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class DensityVerticalHeaderComponent {

    
}
